import { render, staticRenderFns } from "./PoligraphyCards.vue?vue&type=template&id=61827c24&"
import script from "./PoligraphyCards.vue?vue&type=script&lang=js&"
export * from "./PoligraphyCards.vue?vue&type=script&lang=js&"
import style0 from "./PoligraphyCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61827c24')) {
      api.createRecord('61827c24', component.options)
    } else {
      api.reload('61827c24', component.options)
    }
    module.hot.accept("./PoligraphyCards.vue?vue&type=template&id=61827c24&", function () {
      api.rerender('61827c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/PoligraphyCards.vue"
export default component.exports